export enum ILoginStatusEnum {
  FAILED = '0',
  SUCCESS = '1',
  CITIZEN_ID_NOT_REGISTERED = '2',
  CITIZEN_ID_NO_PASSWORD = '3',
  INCORRECT_PASSWORD = '4',
  ACCOUNT_PENDING_APPROVAL = '5',
  NO_ACCESS_PERMISSION = '6',
  UNREGISTERED_ACCOUNT = '7',
  INVALID_AUTHENTICATION = '8',
}
